let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9lBT0")).then(() => parcelRequire('eKi5T'));